import { Box, Grid2, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { Center } from "@mantine/core";
import TabPanel from "@mui/lab/TabPanel";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import { CaseDetailsPanel } from "./_components/ticket-caseDetailsPanel";
import { TicketInfoPanel } from "./_components/ticket-infoPanel"
import { TicketListPanel } from "./_components/ticket-listPanel"
import { TicketActionPanel } from "./_components/ticket-actionPanel"
import { useParams } from "react-router";
import { TicketQueryPanel } from "./_components/ticket-queryPanel";
import { TicketFilePanel } from "./_components/ticket-filePanel";
import { TicketHistoryPanel } from "./_components/ticket-historyPanel";
import { TicketClosingChecklistAgentPanel } from "./_components/ticket-closingChecklistAgentPanel";
import { TicketClosingChecklistClientPanel } from "./_components/ticket-closingChecklistClientPanel";
import { accountService } from "../../_services/accounts.service";
import { PaperTableHeader } from "../../_components/table/header.table";


export const TicketAgentView = () => {

    const [value, setValue] = useState("1");
    const { caseId } = useParams<{ caseId: string }>();
    const handleChange = (event: React.SyntheticEvent, newValue: string) => {
        setValue(newValue);
    };
    const [paymentDate, setPaymentDate] = useState<string>();
    const [invoiceNumber, setInvoiceNumber] = useState<string>();

    return (
        <>
            <PaperTableHeader title="Ticket Detail" />
            <Grid2 container spacing={1} p={2}>
                <Grid2 size={{ xs: 12, sm: 4, md: 3 }}>
                    <TicketInfoPanel setPaymentDate={setPaymentDate} setInvoiceNumber={setInvoiceNumber} />
                </Grid2>
                <Grid2 size={{ xs: 12, sm: 8, md: 9 }}>
                    <Grid2 container spacing={1}>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketActionPanel />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketQueryPanel />
                        </Grid2>
                        <Grid2 size={{ xs: 12, sm: 6, md: 4 }}>
                            <TicketFilePanel />
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        </>
    );
};